import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=da34d1f6"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./EditCategoryDialog.vue?vue&type=style&index=0&id=da34d1f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports